import React from 'react';
import ReactDOM from 'react-dom';

import Sheet from './Sheet';

const Modal = ({
  className,
  children,
  type,
  onClickBackdrop,
  ...props
}) => {
  const classes = ['Modal'];
  if (className) {
    classes.push(className);
  }
  classes.push('type-' + (type || 'sections'));
  const element = <div onClick={onClickBackdrop} className={classes.join(' ')} {...props}>
    <Sheet onClick={(event) => event.stopPropagation()}>
      {children}
    </Sheet>
  </div>;
  const target = document.getElementById('modalTarget');
  //Dem Body wird hidden zugewiesen, da hier das System nicht automatisch zum Anfang scrollt
  document.body.style.overflowY = 'hidden';
  return target && (target.offsetWidth !== 0 || target.offsetHeight !== 0) ? ReactDOM.createPortal(
    element,
    target
  ) : element;
};

export default Modal;
